<template>
  <div class="releasesList">
    <ReleaseListItem
      v-for="(distributions, version) in releases"
      :key="version"
      :distributions="distributions"
      :version="version"
    />
    <div style="padding-top: 5px;">
      <GetMoreButton
        v-if="showMoreButton"
        label="List more releases"
        data-automation="list-more-releases-button"
        :prevent-auto-scroll="preventAutoScroll"
        @getMore="getNext"
      />
    </div>
  </div>
</template>

<script>

import ReleaseListItem from './ReleaseListItem'
import GetMoreButton from '../GetMoreButton'

export default {
  name: 'ReleasesList',
  components: {
    ReleaseListItem,
    GetMoreButton,
  },
  props: {
    releases: {
      type: Object,
      required: true,
    },
    showMoreButton: {
      type: Boolean,
      required: true,
    },
    getNext: {
      type: Function,
      required: true,
    },
    preventAutoScroll: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}

</script>
